const EXCHANGERS = [
  {
    id: 1,
    caption: 'BYBIT',
    disabled: {},
  },
  {
    id: 2,
    caption: 'BINANCE',
    disabled: {},
  },
];

const MAKER_ROLES = [
  {
    id: 0,
    caption: 'Trader',
  },
  {
    id: 1,
    caption: 'Merchant',
  },
];

const DIRECTIONS = [
  {
    id: 1,
    caption: 'Buy',
  },
  {
    id: 2,
    caption: 'Sell',
  },
];

export default {
  EXCHANGERS,
  MAKER_ROLES,
  DIRECTIONS,
};
